module.exports = __webpack_public_path__ + "img/UI_shouji_AZ_ios1280_bd7c08507.png";